<template>
	<div class="p-fluid p-mb-6">
		<div style="display: flex;">
			<b v-if="questionMark">
				<QuestionComments :questionMark="questionMark" :question="question" />
			</b>
			<b v-else> {{ question }} </b>
			<!-- <p>
				<b>{{ question }}</b>
			</p> -->
			<HelpTooltip v-if="bookmark != undefined" :helpbookmark="bookmark" />
		</div>
		<!-- Listen to on change event instead of v-on:input to achieve same result as v-model.lazy -->
		<!-- <input
        v-bind:value="value"
        v-on:change="$emit('input', $event.target.value)"
      > -->
		<template v-for="(item, index) in localValue">
			<InputText
				class="p-mb-2"
				type="text"
				:value="item"
				:key="index"
				:ref="index"
				@change="update(index, $event.target.value)"
				:placeholder="placeholder"
			/>
		</template>
		<div class="p-ml-4">
			<Button
				icon="pi pi-minus"
				class="p-mr-2 p-d-inline p-button-rounded p-button-danger"
				@click="removeLastValue()"
			/>
			<Button
				icon="pi pi-plus"
				class="p-d-inline p-button-rounded p-button-success"
				@click="addNewValue()"
			/>
		</div>
	</div>
</template>

<script>
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import HelpTooltip from "../components/HelpTooltip";
import QuestionComments from "./QuestionComments.vue";

export default {
	name: "InputTextSingleLineMulti",
	props: {
		question: String,
		value: Array,
		placeholder: String,
		bookmark: String,
		questionMark: String
	},
	components: {
		InputText,
		Button,
		HelpTooltip,
		QuestionComments
	},
	data() {
		return {
			localValue: Array.isArray(this.value) ? [...this.value] : []
		};
	},
	watch: {
		value(newVal) {
			// A realtime sync echo can arrive slightly behind a local add/edit
			// (it reflects the pre-edit server state). Only accept an external
			// update here if it isn't older/shorter than what's already showing,
			// so a just-added row doesn't get wiped out from under the user.
			if (Array.isArray(newVal) && newVal.length >= this.localValue.length) {
				this.localValue = [...newVal];
			}
		}
	},
	methods: {
		update: function(index, item) {
			this.$set(this.localValue, index, item);
			this.$emit("input", this.localValue);
		},
		removeLastValue: function() {
			this.localValue.pop();
			this.$emit("input", this.localValue);
		},
		addNewValue: function() {
			this.localValue.push("");
			this.$emit("input", this.localValue);
			const lastIndex = this.localValue.length - 1;
			// Wait until next tick so component is rendered
			this.$nextTick(() => {
				this.$refs[lastIndex][0].$el.focus();
			});
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
